//Users
export const GET_LIST_USER_REQUEST = 'instalent/GET_LIST_USER_REQUEST';
export const GET_LIST_USER_SUCCESS = 'instalent/GET_LIST_USER_SUCCESS';
export const GET_LIST_USER_FAIL = 'instalent/GET_LIST_USER_FAIL';

export const BLOCK_USER_REQUEST = 'instalent/BLOCK_USER_REQUEST';
export const BLOCK_USER_SUCCESS = 'instalent/BLOCK_USER_SUCCESS';
export const BLOCK_USER_FAIL = 'instalent/BLOCK_USER_FAIL';